/*
 *
 * ProductSearch constants
 *
 */

export const INI_COMBOS_CALCULATOR_ACTION = 'app/ProductSearch/INI_COMBOS_CALCULATOR_ACTION';
export const SET_FAMILY_ACTION = 'app/ProductSearch/SET_FAMILY_ACTION';
export const SET_PRODUCT_ACTION = 'app/ProductSearch/SET_PRODUCT_ACTION';
